/* Per-game benchmarks interactivity (loaded with defer by sections/main-game.liquid).
   The DEFAULT view (1080p / No-RT / All brands) is server-rendered visible + sorted, so
   the table is in first paint, crawlable, and shifts nothing. This file is pure
   enhancement: it only re-filters/re-sorts when the user clicks a toggle. No work on load. */
(function () {
  function init() {
    var root = document.getElementById('gd-rows');
    if (!root) return;
    var panel = root.closest('.gd');
    if (!panel || panel.getAttribute('data-gd-init') === '1') return;
    panel.setAttribute('data-gd-init', '1');

    var state = { res: '1080', brand: '', rt: 'false', preset: '0' };
    var bothRT = panel.getAttribute('data-both-rt') === '1';
    var hasPresets = panel.getAttribute('data-has-presets') === '1';
    // Rows are server-rendered once and never added/removed — cache the list + child refs
    // + parsed FPS values once, so a toggle does zero re-querying / re-parsing.
    var rows = [].slice.call(root.querySelectorAll('.gd-row')).map(function (r) {
      return {
        el: r,
        f1080: parseFloat(r.getAttribute('data-f1080')) || 0,
        f1440: parseFloat(r.getAttribute('data-f1440')) || 0,
        f4k: parseFloat(r.getAttribute('data-f4k')) || 0,
        brand: r.getAttribute('data-brand'),
        preset: r.getAttribute('data-preset'),
        rt: String(r.getAttribute('data-rt')),
        num: r.querySelector('.gd-row__fpsnum'),
        fps: r.querySelector('.gd-row__fps'),
        fill: r.querySelector('.gd-row__fill'),
        m60: r.querySelector('.gd-row__mark--60'),
        m120: r.querySelector('.gd-row__mark--120')
      };
    });

    function updSettings() {
      var bothRT = panel.getAttribute('data-both-rt') === '1';
      var hasPresets = panel.getAttribute('data-has-presets') === '1';
      var s = panel.getAttribute('data-base-settings') || '';
      if (hasPresets) { var pb = panel.querySelector('#gd-preset button.is-active'); if (pb) s = pb.getAttribute('data-settings') || s; }
      var suffix = (bothRT && !hasPresets) ? (state.rt === 'true' ? ' / RT High' : ' / No Ray Tracing') : '';
      var el = panel.querySelector('#gd-settings'); if (el) el.textContent = s + suffix;
    }

    function fpsOf(o) { return o['f' + state.res] || 0; }
    function color(f) { if (f >= 120) return '#78C841'; if (f >= 60) return '#B4E50D'; if (f >= 30) return '#FF9B2F'; return '#FB4141'; }
    function render() {
      if (!rows.length) return;
      var shown = rows.filter(function (o) {
        if (hasPresets && o.preset !== state.preset) return false;
        if (bothRT && o.rt !== state.rt) return false;
        if (state.brand && o.brand !== state.brand) return false;
        return true;
      });
      var max = 144;
      shown.forEach(function (o) { var f = fpsOf(o); if (f > max) max = f; });
      shown.sort(function (a, b) { return fpsOf(b) - fpsOf(a); });
      // All reads (fpsOf, max) happened above — now write + reorder in one batched pass.
      rows.forEach(function (o) { o.el.style.display = 'none'; });
      var frag = document.createDocumentFragment();
      shown.forEach(function (o) {
        var f = fpsOf(o), c = color(f);
        o.el.style.display = 'block';
        if (o.num) o.num.textContent = Math.round(f);
        if (o.fps) o.fps.style.color = c;
        if (o.fill) { o.fill.style.width = (f / max * 100) + '%'; o.fill.style.background = c; }
        if (o.m60) o.m60.style.left = (60 / max * 100) + '%';
        if (o.m120) o.m120.style.left = (120 / max * 100) + '%';
        frag.appendChild(o.el);
      });
      root.appendChild(frag);
    }

    panel.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-res], button[data-brand], button[data-rt], button[data-preset]');
      if (!b || !panel.contains(b)) return;
      var group = b.parentElement;
      if (b.hasAttribute('data-res')) state.res = b.getAttribute('data-res');
      else if (b.hasAttribute('data-brand')) state.brand = b.getAttribute('data-brand');
      else if (b.hasAttribute('data-rt')) state.rt = b.getAttribute('data-rt');
      else if (b.hasAttribute('data-preset')) state.preset = b.getAttribute('data-preset');
      [].forEach.call(group.querySelectorAll('button'), function (x) { x.classList.toggle('is-active', x === b); });
      updSettings();
      render();
    });
    // No render on load — the server already rendered the default view.
  }
  // init() is idempotent (data-gd-init guard); hook every phase so the toggles wire up
  // regardless of when this deferred asset executes on the metaobject route.
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
